import { useEffect, useState } from 'react';

/** How long loading must last before a skeleton shows (UI standards: no flash). */
export const LOADING_DELAY_MS = 200;

/** true once `active` has stayed true for `delay` ms (avoids skeleton flashes). */
export const useDelayedFlag = (active, delay = LOADING_DELAY_MS) => {
  const [shown, setShown] = useState(false);
  useEffect(() => {
    if (!active) {
      setShown(false);
      return undefined;
    }
    const timer = setTimeout(() => setShown(true), delay);
    return () => clearTimeout(timer);
  }, [active, delay]);
  return shown;
};

export default useDelayedFlag;
